<div [ngClass]="isOverviewCollapsed ? 'collapsed' : 'expanded'" class="sidebar-item">
  <div (click)="toggleOverview(overviewCollapse)" class="sidebar-item-head">
    <h3 class="h6 mb-0 text-white">
      <i class="fa-solid fa-industry mr-2"></i> {{'Overview'|translate}}
    </h3>
  </div>
  <div #overviewCollapse="ngbCollapse" [(ngbCollapse)]="isOverviewCollapsed" [animation]="false" class="sidebar-item-content">
    <div class="menu menu-overview">

      <!-- Root layer -->
      @if (displayRootMenu) {
        <div class="menu-folder">
          <scitis-menu-item (menuItemSelected)="onRootGroupSelected()" [menuItem]="rootMenuItem"
          class="scitis-menu-item"></scitis-menu-item>
          <div class="menu-item-functions">
            @if (isAdminOrHigher && !userRole.isDistributorRole && !rootMenuItem.disabled) {
              <button (click)="open($event, rootMenuItem)"
                [ngbTooltip]="rootFolderTooltip | async"
                class="btn btn-xs btn-secondary d-none d-md-inline-flex"
                container="body"
                tooltipClass="text-nowrap">
                <i class="fa-solid fa-pen"></i>
              </button>
            }
          </div>
        </div>
      }

      <!-- Go back to parent layer -->
      @if (selectedChildMenuItem) {
        <div (click)="goToParent()" class="menu-folder" [ngClass]="backButtonClass">
          <scitis-menu-item [menuItem]="selectedChildMenuItem" [isLoadingMenuItemParent]="isLoadingMenuItemParent" class="scitis-menu-item"></scitis-menu-item>
          <div class="menu-item-functions">
            @if (displayEditFolderButton && !selectedChildMenuItem.disabled) {
              <button (click)="open($event, selectedChildMenuItem)"
                [ngbTooltip]="folderTooltip | async"
                triggers="hover"
                class="btn btn-xs btn-secondary d-none d-md-inline-flex text-white"
                container="body"
                tooltipClass="text-nowrap">
                <i class="fa-solid fa-pen"></i>
              </button>
            }
          </div>
        </div>
      }

      <!-- Current layers -->
      <div class="menu-content mb-3">
        <!-- Menu is loading -->
        <scitis-loading-items class="scitis-menu-item scitis-menu-item-loader"
        [display]="hierarchyIsLoading"></scitis-loading-items>

        @for (childMenuItem of childMenuItemsToDisplay; track childMenuItem) {
          <scitis-menu-item (menuItemSelected)="onMenuItemSelected($event)"
            [expandNodeInProgress]="expandNodeInProgress"
            [expandedNodeId]="expandedNodeId" [menuItem]="childMenuItem"
            [nodeUserMenuItems]="nodeUserMenuItems"
            [showNodeUserMenuItems]="showNodeUserMenuItems"
            [firebaseUserId]="firebaseUserId"
            [interactiveDataAnalysisMenuItem]="interactiveDataAnalysisMenuItem"
          class="scitis-menu-item" [ngClass]="getClass(childMenuItem)"></scitis-menu-item>
        }
        @if (folderIsEmpty) {
          <div class="alert alert-light text-center my-1">
            <i class="fa-solid fa-folder-open mr-1"></i>
            {{ 'This folder is empty' | translate }}.
          </div>
        }

        @if (moreItemsAreAvailable) {
          <button (click)="loadMoreChildren()" class="btn btn-primary btn-block mt-2">
            <span class="fa-solid fa-angles-down"></span>
            <span translate>Load more</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
